/* ============================================================
   NouNou Lazy Blur-up
   - loading="lazy" 이미지가 아직 로드 전이면 블러 처리 → load되면 쓱 선명하게.
   - 이미 로드/캐시된 이미지엔 적용 안 함(깜빡임 방지).
   - 섹션 재렌더/카트/무한스크롤 등 동적으로 추가되는 이미지도 MutationObserver로 처리.
   ============================================================ */
(function () {
  function reveal(img) {
    img.classList.add('is-loaded');
  }

  function enhance(img) {
    if (img.dataset.nnBlur) return;       // 이미 처리됨
    img.dataset.nnBlur = '1';

    // 이미 로드 완료(캐시 등)면 효과 없이 그대로 둠
    if (img.complete && img.naturalWidth > 0) return;

    img.classList.add('nn-blur-img');

    var done = function () {
      reveal(img);
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
    };
    img.addEventListener('load', done);
    img.addEventListener('error', done); // 실패해도 숨김 상태로 두지 않음

    // 리스너 부착과 load 사이 경합 대비
    if (img.complete && img.naturalWidth > 0) done();
  }

  function scan(root) {
    var imgs = (root || document).querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) enhance(imgs[i]);
  }

  function init() {
    scan(document);

    // 동적으로 추가되는 이미지 처리
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var nodes = muts[i].addedNodes;
          if (!nodes) continue;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'IMG') {
              if (n.getAttribute('loading') === 'lazy') enhance(n);
            } else if (n.querySelectorAll) {
              scan(n);
            }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
